import {initEventsDropdown, prepareLimit} from './tabs-limit.js';
import {initEventsButton} from './tabs-navigation.js';
import {select} from './tabs-core.js';
import {onPageReady} from '@kuik/modules/loader/script-loader-helper.js';

export function initTabs(tabs) {
  const tabButtonsList = Array.from(tabs.querySelectorAll(`[data-scope="${tabs.dataset.key}"] > .js-tabs__button`));
  initEventsButton(tabs, tabButtonsList);
  let selectedTab = tabs.querySelector(`[data-scope="${tabs.dataset.key}"] > .js-tabs__button[data-selected="true"]`);
  if (selectedTab) {
    delete selectedTab.dataset.selected;
  } else {
    selectedTab = tabButtonsList[0];
  }
  select(selectedTab);

}

/**
 * Attente que la page soit entièrement chargée.
 */
onPageReady(() => {

  /**
   * Initialisation des onglets.
   */
  document.querySelectorAll('.js-tabs.js-tabs-not-initialized').forEach((tabs) => {
    initTabs(tabs);
    tabs.classList.remove('js-tabs-not-initialized');
  });

  /**
   * Préparation des limites
   */
  document.querySelectorAll('.js-tabs.tabs--limited.js-limit-not-initialized').forEach((tabs) => {
    prepareLimit(tabs);
    initEventsDropdown(tabs);
    tabs.classList.remove('js-limit-not-initialized');
  });
});
